// extracted by mini-css-extract-plugin
export var borderTop = "_l-3";
export var linkIcon = "_l-5";
export var linkIconSm = "_l-6";
export var linkOutCard = "_l-7 _l-4";
export var linkRow = "_l-2";
export var pageContainer = "_l-1";
export var providerIcon = "_l-8";
export var roundedBorder = "_l-4";
export var settingsContent = "_l-0";